import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Rowbox from '../Common/Rowbox'
import {
  DECORATION_EASY_CHAT,
  PRIVILEGE_EASY_CHAT,
  PRIVILEGE_STATUS_REJECTED,
  PRIVILEGE_STATUS_VERIFYING,
  DECORATION_DEFAULT_TEXT
} from '@constant'
import { dGet } from '@core/utils'
import Img from '@UI/Img'
import { isSiDaMember } from '@util'

@observer
export default class extends Component {
  componentDidMount() {
    this.props.store.getEasyChat()
  }

  getStatus = () => {
    const { allStatus } = this.props.store

    let status = ''

    const privileges = dGet(allStatus, 'privileges', [])

    const chat = privileges.filter(item => +item.id === PRIVILEGE_EASY_CHAT)[0]

    if (chat) {
      if (chat.status == PRIVILEGE_STATUS_REJECTED) {
        status = 'rejected'
      } else if (chat.status == PRIVILEGE_STATUS_VERIFYING) {
        status = 'verifying'
      }
    }

    return status
  }

  showModule = home_speech => {
    // 三大个人，但团队未设置
    if (isSiDaMember() && !home_speech) {
      return false
    }

    return true
  }

  render() {
    const {
      store: { homeData, easyChat }
    } = this.props
    const { logo_path_square, logo_path } = homeData
    const home_speech = dGet(easyChat, 'home_speech')
    const text = home_speech || DECORATION_DEFAULT_TEXT[DECORATION_EASY_CHAT]
    const status = this.getStatus()

    return this.showModule(home_speech) ? (
      <Rowbox
        type={DECORATION_EASY_CHAT}
        store={this.props.store}
        style={{
          height: 'auto',
          backgroundColor: 'transparent',
          marginBottom: 0
        }}
        vCenter={false}
        status={status}
        disableEdit={isSiDaMember() && home_speech}
      >
        <div
          style={{
            marginBottom: '10px',
            width: '100%',
            backgroundColor: 'rgb(64, 64, 64)',
            color: 'rgb(255, 255, 255)',
            display: 'flex',
            alignItems: 'center',
            padding: '10px 20px'
          }}
        >
          <Img
            src={logo_path_square || logo_path}
            style={{
              width: 36,
              height: 36,
              borderRadius: '50%',
              marginRight: 10,
              flexShrink: 0
            }}
          />
          <div>
            <div
              style={{
                width: 250,
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap'
              }}
            >
              {text}
            </div>
            <div>来自私信 > </div>
          </div>

          <div
            style={{
              position: 'absolute',
              bottom: 0,
              width: '0px',
              height: '0px',
              borderWidth: '10px 10px 0px',
              borderStyle: 'solid',
              borderColor: 'rgb(64, 64, 64) transparent transparent'
            }}
          />
        </div>
      </Rowbox>
    ) : null
  }
}
